import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/modules/dashboard/list'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
    import news from '@/views/modules/news/list'
    import discussjianshenxiangmu from '@/views/modules/discussjianshenxiangmu/list'
    import discussjiaolianxinxi from '@/views/modules/discussjiaolianxinxi/list'
    import jiaolianxinxi from '@/views/modules/jiaolianxinxi/list'
    import xiangmufenlei from '@/views/modules/xiangmufenlei/list'
    import jianshenxiangmu from '@/views/modules/jianshenxiangmu/list'
    import yonghu from '@/views/modules/yonghu/list'
    import jiaolian from '@/views/modules/jiaolian/list'
    import config from '@/views/modules/config/list'
    import jiaolianyuyue from '@/views/modules/jiaolianyuyue/list'
    import setAvailability from '@/views/modules/jiaolianyuyue/setAvailability';
    import Availability from '@/views/modules/jiaolianyuyue/Availability';
    import allCoachesAvailability from '@/views/modules/jiaolianyuyue/allCoachesAvailability';
    import batchAddAvailability from '@/views/modules/jiaolianyuyue/batchAddAvailability';

    import recharge from '@/views/modules/yonghu/recharge';
    import rechargeList from '@/views/modules/yonghu/rechargeList';

    // 新增导入充值规则和VIP订单记录组件
    import chongzhiguize from '@/views/modules/chongzhiguize/list';
    import viporder from '@/views/modules/viporder/list';

    // 导入VIP相关组件
import viprule from '@/views/modules/viprule/list'
import vippurchase from '@/views/modules/vippurchase/index'
import vipyonghu from '@/views/modules/vipyonghu/list'
import refund from '@/views/modules/refund/list'
import cashier from '@/views/modules/payment/cashier'
import paymentrecord from '@/views/modules/paymentrecord/list'
import offlinepayment from '@/views/modules/payment/offline'
import appointmentPaid from '@/views/modules/jiaolianyuyue/appointment-paid'
import appointmentUnpaid from '@/views/modules/jiaolianyuyue/appointment-unpaid'
import notification from '@/views/modules/notification/index'

// 导入店铺管理组件
import shop from '@/views/modules/shop/list'
import shopcoach from '@/views/modules/shopcoach/list'

// 导入文档管理组件
import document from '@/views/modules/document/list'
import documentcoach from '@/views/modules/documentcoach/list'
import dashboard from '@/views/modules/dashboard/list'
import memberAnalysis from '@/views/statistics/member-analysis.vue'
import reportCenter from '@/views/statistics/report-center.vue'
import jiaolianzidonggengxin from '@/views/modules/jiaolianzidonggengxin/schedule-mode.vue'
import HomepageConfig from '@/views/modules/homepage/HomepageConfig.vue'
// import coachstatus from '@/views/modules/jiaolian/CoachStatus.vue'

// 新增导入礼品卡相关组件
import giftcard from '@/views/modules/giftcard/list'
import giftcardpurchase from '@/views/modules/giftcard/purchase'
import giftcardorder from '@/views/modules/giftcard/order'

import product from '@/views/modules/product/list'
import commission from '@/views/modules/commission/rule-list'
import inventory from '@/views/modules/inventory/ledger-list'
import inoutventory from '@/views/modules/inventory/stock-stats'
import commissionlist from '@/views/modules/commission/record-list'
import saleorder from '@/views/modules/sale/order-list'


//2.配置路由   注意：名字
const routes = [{
    path: '/index',
    name: '首页',
    component: Index,
    children: [{
      // 这里不设置值，是把main作为默认页面
      path: '/',
      name: '首页',
      component: Home,
      meta: {icon:'', title:'center'}
    }, {
      path: '/updatePassword',
      name: '修改密码',
      component: UpdatePassword,
      meta: {icon:'', title:'updatePassword'}
    }, {
      path: '/pay',
      name: '支付',
      component: pay,
      meta: {icon:'', title:'pay'}
    }, {
      path: '/center',
      name: '个人信息',
      component: center,
      meta: {icon:'', title:'center'}
    }
      ,{
	path: '/news',
        name: '健身资讯',
        component: news
      }
      ,{
	path: '/discussjianshenxiangmu',
        name: '健身项目评论',
        component: discussjianshenxiangmu
      }
      ,{
	path: '/discussjiaolianxinxi',
        name: '教练信息评论',
        component: discussjiaolianxinxi
      }
      ,{
	path: '/jiaolianxinxi',
        name: '教练信息',
        component: jiaolianxinxi
      }
      ,{
	path: '/xiangmufenlei',
        name: '项目分类',
        component: xiangmufenlei
      }
      ,{
	path: '/jianshenxiangmu',
        name: '健身项目',
        component: jianshenxiangmu
      }
      ,{
	path: '/yonghu',
        name: '用户',
        component: yonghu
      }
      ,{
	path: '/jiaolian',
        name: '教练',
        component: jiaolian
      }
      ,{
	path: '/config',
        name: '轮播图管理',
        component: config
      }
      ,{
        path: '/homepage-config',
        name: '主页管理',
        component: HomepageConfig
      }
      ,{
	path: '/jiaolianyuyue',
        name: '教练预约',
        component: jiaolianyuyue
      }
      ,{
        path: '/setAvailability',
        name: '添加空闲时间',
        component: setAvailability
      }
      ,{
        path: '/availability',
        name: '教练可用时间',
        component: Availability,
      },
      {
        path: '/allCoachesAvailability',
        name: '所有教练可用时间',
        component: allCoachesAvailability,
      },
      {
        path: '/recharge',
        name: '充值',
        component: recharge,
      },
      {
        path: '/rechargeList',
        name: '充值记录',
        component: rechargeList,
      },
      {
        path: '/chongzhiguize',
        name: '充值规则',
        component: chongzhiguize
      },
      {
        path: '/viporder',
        name: 'VIP记录',
        component: viporder
      },
      {
        path: '/viprule',
        name: 'VIP管理',
        component: viprule
      },
      {
        path: '/vippurchase',
        name: 'VIP购买',
        component: vippurchase
      },
      {
        path: '/vipyonghu',
        name: 'VIP用户列表',
        component: vipyonghu
      },
      {
        path: '/refund',
        name: '退款处理',
        component: refund
      },
      {
        path: '/cashier',
        name: '付款',
        component: cashier
      },
      {
        path: '/offlinepayment',
        name: '到店付款',
        component: offlinepayment
      },
      {
        path: '/paymentrecord',
        name: '预约支付记录',
        component: paymentrecord
      },
      {
        path: '/notification',
        name: '消息管理',
        component: notification
      },
      {
        path: '/appointment-paid',
        name: '预约支付记录(预约维度)',
        component: appointmentPaid
      },
      {
        path: '/appointment-unpaid',
        name: '未付款记录',
        component: appointmentUnpaid
      },
      {
        path: '/shop',
        name: '店铺管理',
        component: shop
      },
      {
        path: '/shopcoach',
        name: '店铺教练绑定',
        component: shopcoach
      },
      {
        path: '/document',
        name: '文档管理',
        component: document
      },
      {
        path: '/documentcoach',
        name: '教练文档管理',
        component: documentcoach
      },
      {
        path: '/dashboard',
        name: '统计分析',
        component: dashboard
      },
      {
        path: '/memeber-analysis',
        name: 'member分析',
        component: memberAnalysis
      },
      {
        path: '/report-center',
        name: '分析中心',
        component: reportCenter
      },
      {
        path: '/jiaolianzidonggengxin',
        name: '教练空闲时间自动更新模式',
        component: jiaolianzidonggengxin
      },
      // {
      //   path: '/coachstatus',
      //   name: '教练状态',
      //   component: coachstatus
      // },
      {
        path: '/upgraderule',
        name: '升级类型设置',
        component: () => import('@/views/modules/upgraderule/list')
      },
      {
        path: '/upgrade-add',
        name: '升级添加',
        component: () => import('@/views/modules/upgrade/add')
      },
      {
        path: '/upgrade',
        name: '升级订单列表',
        component: () => import('@/views/modules/upgrade/list')
      },
      // 场控管理路由
      {
        path: '/room',
        name: '房间管理',
        component: () => import('@/views/modules/room/list')
      },
      {
        path: '/room/add-or-update',
        name: '添加/修改房间',
        component: () => import('@/views/modules/room/add-or-update')
      },
      {
        path: '/roomcalendar',
        name: '房间日历',
        component: () => import('@/views/modules/roomcalendar/calendar')
      },
      {
        path: '/roomcleaning',
        name: '清洁计划',
        component: () => import('@/views/modules/roomcleaning/list')
      },
      {
        path: '/giftcard',
        name: '礼品卡设置',
        component: giftcard
      },
      {
        path: '/giftcardpurchase',
        name: '礼品卡购买',
        component: giftcardpurchase
      },
      {
        path: '/giftcardorder',
        name: '礼品卡记录',
        component: giftcardorder
      },
      {
        path: '/product',
        name: '库存管理',
        component: product
      },
      {
        path: '/commission',
        name: '提成管理',
        component: commission
      },
      {
        path: '/inventory',
        name: '仓库管理',
        component: inventory
      },
      {
        path: '/inoutventory',
        name: '出入仓库管理',
        component: inoutventory
      },
       {
        path: '/commissionlist',
        name: '提成记录管理',
        component: commissionlist
      },
      {
        path: '/saleorder',
        name: '销售管理',
        component: saleorder
      },
      {
        path: '/batchAddAvailability',
        name: '批量添加空闲时间',
        component: batchAddAvailability
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {icon:'', title:'login'}
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {icon:'', title:'register'}
  },
  {
    path: '/',
    name: '首页',
    redirect: '/index'
  }, /*默认跳转路由*/
  {
    path: '*',
    component: NotFound
  }
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
  mode: 'hash',
  /*hash模式改为history*/
  routes // （缩写）相当于 routes: routes
})
// 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLoggedIn = localStorage.getItem('Token');
//   if (to.path !== '/login' && !isLoggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });
// 添加路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('Token');
  if (to.path !== '/login' && to.path !== '/register' && !isLoggedIn) {
    next('/login');
  } else {
    next();
  }
});


export default router;
